import type { SVGProps } from 'react';
const SvgSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="3 2.903 20 19.832"
    {...props}
  >
    <path d="M11.719 3.712a.936.936 0 0 1-.684 1.136 8.13 8.13 0 0 0-6.16 7.887A8.124 8.124 0 0 0 13 20.86a8.124 8.124 0 0 0 8.125-8.125 8.13 8.13 0 0 0-6.16-7.887.936.936 0 0 1-.684-1.136.937.937 0 0 1 1.137-.684C19.773 4.11 23 8.044 23 12.735c0 5.524-4.477 10-10 10s-10-4.476-10-10c0-4.691 3.227-8.625 7.582-9.707a.94.94 0 0 1 1.137.684" />
  </svg>
);
export default SvgSpinner;
